import { Injectable } from '@angular/core';
import { ApiService, DocumentoOficial, TipoDocumentoOficial } from '../../api.service';
import { ServicoFormatacao } from '../../shared/servico-formatacao';
import { dataIsoLocal, filtroListagemDocumentosPadrao } from './regras-listagem-documentos';

@Injectable({ providedIn: 'root' })
export class ServicoDocumentoOficial {
  constructor(
    private readonly api: ApiService,
    private readonly servicoFormatacao: ServicoFormatacao
  ) {}

  tipos(): Array<{ id: TipoDocumentoOficial; rotulo: string }> {
    return [
      { id: 'OFICIO', rotulo: 'Ofício' },
      { id: 'PORTARIA', rotulo: 'Portaria' },
      { id: 'DECRETO', rotulo: 'Decreto' }
    ];
  }

  rotuloTipo(tipo?: TipoDocumentoOficial) {
    return this.tipos().find(item => item.id === tipo)?.rotulo || tipo || '';
  }

  listarCadastros(empregadorId: string) {
    return this.api.listarCadastrosDocumentosOficiais(empregadorId);
  }

  listar(
    empregadorId: string,
    dataInicial: string,
    dataFinal: string,
    tipo?: TipoDocumentoOficial,
    pagina = 1,
    limite = 50
  ) {
    return this.api.listarDocumentosOficiais(empregadorId, dataInicial, dataFinal, tipo, pagina, limite);
  }

  cadastrar(empregadorId: string, tipo: TipoDocumentoOficial, numero: number, ano: number) {
    return this.api.cadastrarDocumentoOficial(empregadorId, tipo, numero, ano);
  }

  reservar(empregadorId: string, tipo: TipoDocumentoOficial, ano: number, quantidade: number) {
    return this.api.reservarDocumentosOficiais(empregadorId, tipo, ano, quantidade);
  }

  editar(item: DocumentoOficial) {
    return this.api.editarDocumentoOficial(
      item.id,
      item.tipo,
      item.numero,
      item.ano,
      item.dataSolicitacao,
      item.finalidade
    );
  }

  removerSolicitante(id: string) {
    return this.api.removerSolicitanteDocumentoOficial(id);
  }

  listarDoServidor() {
    return this.api.listarDocumentosServidor();
  }

  solicitar(tipo: TipoDocumentoOficial, finalidade: string) {
    return this.api.pedirDocumentoServidor(tipo, finalidade);
  }

  formatarData(valor?: string) {
    return this.servicoFormatacao.formatarDataIso(valor);
  }

  filtroPadrao() {
    return filtroListagemDocumentosPadrao();
  }

  dataIsoHoje() {
    return dataIsoLocal(new Date());
  }
}
